import { useEffect } from 'react';
import { MainApp } from '@wajeez-web/components/layouts';
import {
  addInitializer,
  EndpointItem,
  RouteItem,
} from '@wajeez-web/core/types';
import { initialize, useRouting } from '@wajeez-web/components/helpers';
import { initializeAuth } from '@wajeez-web/modules/auth';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  initializeBusinessGroupRoutes,
  initializeBusinessGroupEndpoints,
} from '@wajeez-web/modules/business-group';
import {
  initializeContentEndpoints,
  initializeContentLookup,
  initializeContentNavigation,
} from '@wajeez-web/modules/content';
import {
  initializeProductsRoutes,
  initializeProductsEndpoints,
} from '@wajeez-web/modules/product';
import {
  initializeCustomersEndpoints,
  initializeCustomersRoutes,
} from '@wajeez-web/modules/customers';
import {
  initializeRolesRoutes,
  initializeRolesEndpoints,
} from '@wajeez-web/modules/roles';
import {
  initializeSalesRoutes,
  initializeSalesEndpoints,
} from '@wajeez-web/modules/sales';
import {
  initializeAnalysisEndpoints,
  initializeAnalysisNavigation,
} from '@wajeez-web/modules/analysis';
import { useAuthSelector, AuthActions } from '@wajeez-web/stores/auth';
import { store } from '@wajeez-web/stores/base';
import {
  useCommonSelector,
  useCommonDispatch,
} from '@wajeez-web/stores/common';
import { useContentSelector } from '@wajeez-web/stores/content';

import { Route, Routes, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  initializeEventsEndpoints,
  initializeEventsRoutes,
} from '@wajeez-web/modules/events';

// initialize(store.dispatch, []);
const clientId =
  '28055906188-mp0vnuc1rvpdahh4eon01i9top95911t.apps.googleusercontent.com';
export default function App() {
  const contentEntityTypeLookups = useContentSelector(
    (s) => s.contentEntityType.lookups
  );

  const isAuthorized = useAuthSelector(
    (s) =>
      s.auth.token !== null && s.auth.token !== undefined && s.auth.token !== ''
  );

  const initURL = useAuthSelector((state) => state.auth.initURL);
  const permissions = useAuthSelector((state) => state.auth.permission);

  const { dir } = useCommonSelector((state) => state.common.settings);

  const dispatch = useCommonDispatch();
  const { routes, endpoints } = useRouting([
    addInitializer('initializeAuth', 0, initializeAuth),
    addInitializer('initializeContentLookup', 1, initializeContentLookup, [
      isAuthorized,
    ]),
    addInitializer(
      'initializeContentNavigation',
      10,
      initializeContentNavigation,
      [...contentEntityTypeLookups]
    ),
    addInitializer('initializeContentEndpoints', 0, initializeContentEndpoints),
    addInitializer('initializeProductsRoutes', 10, initializeProductsRoutes),
    // addInitializer(
    //   'initializeAnalusisEndpoints',
    //   0,
    //   initializeAnalysisEndpoints
    // ),
    // addInitializer(
    //   'initializeAnalysisNavigation',
    //   10,
    //   initializeAnalysisNavigation
    // ),
    addInitializer(
      'initializeProductsEndpoints',
      0,
      initializeProductsEndpoints
    ),
    addInitializer('initializeCustomersRoutes', 10, initializeCustomersRoutes),

    addInitializer(
      'initializeCustomersEndpoints',
      0,
      initializeCustomersEndpoints
    ),
    addInitializer('initializeSalesRoutes', 10, initializeSalesRoutes),
    addInitializer('initializeSalesEndpoints', 0, initializeSalesEndpoints),
    addInitializer(
      'initializeBusinessGroupRoutes',
      10,
      initializeBusinessGroupRoutes
    ),
    addInitializer(
      'initializeBusinessGroupEndpoints',
      0,
      initializeBusinessGroupEndpoints
    ),
    addInitializer('initializeRolesRoutes', 10, initializeRolesRoutes),
    addInitializer('initializeRolesEndpoints', 0, initializeRolesEndpoints),
    addInitializer('initializeEventsRoutes', 10, initializeEventsRoutes),
    addInitializer('initializeEventsEndpoints', 0, initializeEventsEndpoints),
  ]);

  useEffect(() => {
    const url = endpoints.find((e) =>
      e.per.find((p) => permissions?.includes(p))
    )?.endpoint;

    url && !initURL && dispatch(AuthActions.initUrl(`/${url}`));
  }, [routes, endpoints, initURL]);

  useEffect(() => {
    document.body.setAttribute('dir', dir);
  }, [dir]);

  const theme = createTheme({
    direction: dir,
  });

  return (
    <div className=" text-textPrimary font-tajwal  hover:scrollbar-thumb-gray-700 scrollbar-track-transparent scrollbar-thin">
      <GoogleOAuthProvider clientId={clientId}>
        <ThemeProvider theme={theme}>
          <MainApp routes={routes} endpoints={endpoints} />
        </ThemeProvider>
      </GoogleOAuthProvider>
      {/* <Routes>
        <Route
          path="/*"
          element={<MainApp routes={routes} endpoints={endpoints} />}
        />
      </Routes> */}
    </div>
  );
}
